import type { KPAData } from '@/types/evidence'

const slug = (value?: string | null) => (value ? value.toLowerCase().replace(/\s+/g, '-') : undefined)

/**
 * Every key a KPA's discussion points may be kept under (HR UAT list #4, Oct 2026).
 *
 * The People Leader's screens key a KPA by a slug of its name, with its numeric id as
 * numericId; the Team Member's key it by the numeric id, with the plain name. A check-in
 * keys its loaded points by whichever KPA in the viewer's own list matched, so the People
 * Leader's points and the Team Member's can sit under different keys for the same KPA.
 * Looking a KPA's points up under all of these finds both sides' points, in either
 * person's view and in a completed check-in's snapshot.
 */
export function discussionPointKeys(kpa: Pick<KPAData, 'id' | 'name' | 'display_name' | 'numericId'>): string[] {
  const numericId = kpa.numericId == null ? undefined : String(kpa.numericId)
  return [kpa.id, kpa.name, kpa.display_name, numericId, slug(kpa.name), slug(kpa.display_name)]
    .filter((key, i, all): key is string => !!key && all.indexOf(key) === i)
}
